import GameModel from "../../GameModel";
import { Settings } from "../../Settings";
import Damage from "../crew/Damage";
import Totals from "../crew/Totals";
import LayerDescription from "../grid/LayerDescription";
import { findLayerForHealth, getLayerDescriptionForRow, LayerDescriptionArray, LayerDescriptions } from "../grid/LayerDescriptions";
import BigNum from "../math/BigNum";

export default class PartyTarget extends GameModel {
    /**
     * @param {Totals} totals 
     * @param {Damage} damage
     */
    constructor(totals, damage) {
        super();

        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        // /**
        //  * @type {string}
        //  */
        // this.crewMode = '';

        /**
         * @type {LayerDescription}
         */
        this.layerDescription = LayerDescriptions.DIRT_LAYER;

        /**
         * @type {LayerDescription}
         */
        this.nextLayerDescription = this.findNextLayerDescription();

        /**
         * @constant
         * @type {number}
         */
        this.defaultMineSeconds = 1;

        /**
         * @type {number}
         */
        this.targetMineSeconds = 1;

        /**
         * This is not saved. It is derived.
         * @type {number}
         */
        this.targetRow = 0;

        // /**
        //  * This is not saved. It is derived.
        //  * @type {number}
        //  */
        // this.minRow = 0;

        // /**
        //  * This is not saved. It is derived.
        //  * @type {number}
        //  */
        // this.maxRow = 0;

        /**
         * @constant
         * @type {BigNum}
         */
        this.workingBrickHealth = new BigNum(0);

        /**
         * @constant
         * @type {number}
         */
        this.halfDeltaRows = 15;
    }

    /**
     * Update the target mine seconds to match the specified row.
     * @param {number} rowNumber 
     */
    deriveTargetSecondsForRow(rowNumber) {

        if (this.layerDescription.containsRow(rowNumber)) {
            this.deriveTargetSecondsInternal(this.layerDescription, rowNumber);
            return;
        }

        const prevLayer = this.layerDescription.prevLayer;
        if (prevLayer && prevLayer.containsRow(rowNumber)) {
            this.deriveTargetSecondsInternal(prevLayer, rowNumber);
            return;
        }

        const nextLayer = this.layerDescription.nextLayer;
        if (nextLayer && nextLayer.containsRow(rowNumber)) {
            this.deriveTargetSecondsInternal(nextLayer, rowNumber);
            return;
        }

        const layerDescription = getLayerDescriptionForRow(rowNumber); // O(N) search
        if (layerDescription) {
            this.deriveTargetSecondsInternal(layerDescription, rowNumber);
            return;
        }

        console.log('PartyTarget.deriveTargetSecondsForRow() Failed to update target mine seconds');
    }

    /**
     * @private
     * @param {LayerDescription} layerDescription 
     * @param {number} rowNumber 
     */
    deriveTargetSecondsInternal(layerDescription, rowNumber) {
        // get the health of the selected row
        layerDescription.calculateTileHealth(rowNumber, this.workingBrickHealth);

        this.targetMineSeconds = this.damage.calculateMineSeconds(this.workingBrickHealth);
        //console.log('PartyTarget.deriveTargetSecondsInternal() row=' + rowNumber + ' targetSeconds=' + this.targetMineSeconds);
    }

    /**
     * This should be invoked before we generate a new vector field.
     */
    calculateTargetRow() {

        // Based on mine damage, how much health does a brick have if it takes one second to mine?
        this.damage.calculateMaxBrickHealth(this.targetMineSeconds, this.workingBrickHealth);

        // Calculate the row depth. (LayerDescriptions)
        const layer = findLayerForHealth(this.layerDescription, this.workingBrickHealth);

        // Check the min target row.
        this.targetRow = Math.max(Settings.target.minTargetRow, layer.calculateTileDepth(this.workingBrickHealth));

        //console.log('PartyTarget.calculateTargetRow() targetMineSeconds=' + this.targetMineSeconds + ' targetRow=' + this.targetRow);

        // this.maxRow = this.targetRow + this.halfDeltaRows;
        // this.minRow = this.targetRow - this.halfDeltaRows;
    }

    /**
     * @param {LayerDescription} layerDescription 
     */
    setLayerDescriptionFromSave(layerDescription) {
        this.layerDescription = layerDescription;
        this.nextLayerDescription = this.findNextLayerDescription();

        // Update the party target now that we have a new max layer.
        this.calculateTargetRow();
    }

    /**
     * @returns {LayerDescription}
     */
    findNextLayerDescription() {
        // Layers keep a reference to their next layer.
        const next = this.layerDescription.nextLayer;
        if (next) {
            return next;
        }

        // Older code:
        for (let i = 0; i < LayerDescriptionArray.length; i++) {
            const layerDescription = LayerDescriptionArray[i];
            if (layerDescription.prevLayer === this.layerDescription) {
                return layerDescription;
            }
        }
        return null;
    }

    unlockNextLayer() {
        if (!this.nextLayerDescription) {
            console.log('PartyTarget.unlockNextLayer() No next layer!');
            return;
        }

        this.layerDescription = this.nextLayerDescription;

        // Update the party target now that we have a new target layer.
        this.calculateTargetRow();

        this.nextLayerDescription = this.findNextLayerDescription();

        // Increment the unclaimed prestige
        this.totals.onTerrainLayerUnlocked();
    }


    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.layerDescription = LayerDescriptions.DIRT_LAYER;       
        this.nextLayerDescription = this.findNextLayerDescription();
        this.targetMineSeconds = this.defaultMineSeconds;

        this.calculateTargetRow();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.resetFull();
    }
}